import { createAction } from "redux-act";

export const REQSendPushNoti = createAction("REQUEST_SEND_PUSH_NOTI");
export const RESSendPushNoti = createAction("RECEIVE_SEND_PUSH_NOTI");
export const FailSendPushNoti = createAction("FAILED_SEND_PUSH_NOTI");
export const CleanUpPushNoti = createAction("CLEANUP_SEND_PUSH_NOTI");
